import React, { useContext, useEffect, useState } from "react";
import Card from "canvas-core-react/lib/Card";
import Row from "canvas-core-react/lib/Row";
import Column from "canvas-core-react/lib/Column";
import TextSubtitle from "canvas-core-react/lib/TextSubtitle";
import IconHighAmountIllustrative from "canvas-core-react/lib/IconHighAmountIllustrative";
import IconWithdrawIllustrative from "canvas-core-react/lib/IconWithdrawIllustrative";
import { DoughnutComponent } from "../../chart/doughnut";
import LineSeparator from "canvas-core-react/lib/LineSeparator";
import Margin from "canvas-core-react/lib/Margin";
import TextBody from "canvas-core-react/lib/TextBody";
import "./style.scss";
import { formatThousandsSeparator, getValues } from "../../../utils/utils";
import { CoachContext } from "../../../context";

export const IncomeOutcomeComponent = () => {

  const [incomeFixed, setIncomeFixed] = useState(0);
  const [incomeVariable, setIncomeVariable] = useState(0);
  const [outcomeFixed, setOutcomeFixed] = useState(0);
  const [outcomeVariable, setOutcomeVariable] = useState(0);
  console.log("CoachContext ----aui---", CoachContext);

  const { values } = useContext(CoachContext);

  /* istanbul ignore next */
  useEffect(() => {
    setIncomeFixed(getValues(values, "ingresos", "fijos"));
    setIncomeVariable(getValues(values, "ingresos", "variables"));
    setOutcomeFixed(getValues(values, "egresos", "indispensables"));
    setOutcomeVariable(getValues(values, "egresos", "extra"));
  }, []);

  return (
    <>
      <Card>
        <Row>
          <Column xs={4} sm={8} md={12} lg={12}>
            <TextSubtitle component="span">INGRESOS Y EGRESOS</TextSubtitle>
          </Column>
        </Row>
        <Margin xs={48} sm={48} md={48} lg={48} side="top">
          <Row justifyContent="center">
            <Column xs={4} sm={8} md={4} lg={4}>
              <Margin xs={54} sm={54} md={54} lg={54}>
                <Row>
                  <Column xs={4} sm={8} md={1} lg={1}>
                    <IconHighAmountIllustrative />
                  </Column>
                  <Column className="graph" xs={4} sm={8} md={10} lg={10}>
                    <TextSubtitle
                      component="span"
                      className="graph__income-title"
                    >
                      Total ingresos
                    </TextSubtitle>
                  </Column>
                </Row>
                <Row>
                  <Column lgOffset={2} lg={10}>
                    <TextSubtitle component="span">
                      $
                      {formatThousandsSeparator(
                        parseInt(incomeFixed.toString()) +
                        parseInt(incomeVariable.toString())
                      )}
                    </TextSubtitle>
                  </Column>
                </Row>
              </Margin>
            </Column>
            <Column xs={4} sm={4} md={4} lg={4}>
              <Row>
                <Column xs={4} sm={8} md={12} lg={12}>
                  <DoughnutComponent
                    totalIncome={
                      parseInt(incomeFixed.toString().replaceAll(".", "")) +
                      parseInt(incomeVariable.toString().replaceAll(".", ""))
                    }
                    totalOutcome={
                      parseInt(outcomeFixed.toString().replaceAll(".", "")) +
                      parseInt(outcomeVariable.toString().replaceAll(".", ""))
                    }
                  />
                </Column>
              </Row>
            </Column>
            <Column xs={4} sm={8} md={4} lg={4}>
              <Margin xs={54} sm={54} md={54} lg={54}>
                <Row>
                  <Column lg={1}>
                    <IconWithdrawIllustrative />
                  </Column>
                  <Column className="graph" xs={4} sm={8} md={10} lg={10}>
                    <TextSubtitle
                      component="span"
                      className="graph__outcome-title"
                    >
                      Total egresos
                    </TextSubtitle>
                  </Column>
                  <Column lgOffset={2} lg={10}>
                    <TextSubtitle component="span">
                      $
                      {formatThousandsSeparator(
                        parseInt(outcomeFixed.toString().replaceAll(".", "")) +
                        parseInt(outcomeVariable.toString().replaceAll(".", ""))
                      )}
                    </TextSubtitle>
                  </Column>
                </Row>
              </Margin>
            </Column>
          </Row>
        </Margin>
        <Margin xs={48} sm={48} md={48} lg={48} side="top">
          <LineSeparator />
        </Margin>
        <Margin xs={48} sm={48} md={48} lg={48} side="top">
          <Row>
            <Column xs={4} sm={8} md={6} lg={6} className="graph__asd">
              <Row>
                <Column mdOffset={2} lgOffset={2} xs={4} sm={8} md={10} lg={10}>
                  <TextBody component="span">Ingresos fijos</TextBody>
                </Column>
              </Row>
              <Row>
                <Column mdOffset={2} lgOffset={2} xs={4} sm={8} md={10} lg={10}>
                  <TextSubtitle component="span">
                    ${formatThousandsSeparator(incomeFixed)}
                  </TextSubtitle>
                </Column>
              </Row>
              <Margin xs={20} sm={20} md={20} lg={20}>
                <Row>
                  <Column
                    mdOffset={2}
                    lgOffset={2}
                    xs={4}
                    sm={8}
                    md={10}
                    lg={10}
                  >
                    <TextBody component="span">Ingresos Variables</TextBody>
                  </Column>
                </Row>
                <Row>
                  <Column
                    mdOffset={2}
                    lgOffset={2}
                    xs={4}
                    sm={8}
                    md={10}
                    lg={10}
                  >
                    <TextSubtitle component="span">
                      ${formatThousandsSeparator(incomeVariable)}
                    </TextSubtitle>
                  </Column>
                </Row>
              </Margin>
            </Column>
            <Column xs={4} sm={8} md={6} lg={6}>
              <Row>
                <Column mdOffset={2} lgOffset={2} xs={4} sm={8} md={10} lg={10}>
                  <TextBody component="span">Egresos Indispensables</TextBody>
                </Column>
              </Row>
              <Row>
                <Column mdOffset={2} lgOffset={2} xs={4} sm={8} md={10} lg={10}>
                  <TextSubtitle component="span">
                    ${formatThousandsSeparator(outcomeFixed)}
                  </TextSubtitle>
                </Column>
              </Row>
              <Margin xs={20} sm={20} md={20} lg={20}>
                <Row>
                  <Column
                    mdOffset={2}
                    lgOffset={2}
                    xs={4}
                    sm={8}
                    md={10}
                    lg={10}
                  >
                    <TextBody component="span">Egresos Extras</TextBody>
                  </Column>
                </Row>
                <Row>
                  <Column
                    mdOffset={2}
                    lgOffset={2}
                    xs={4}
                    sm={8}
                    md={10}
                    lg={10}
                  >
                    <TextSubtitle component="span">
                      ${formatThousandsSeparator(outcomeVariable)}
                    </TextSubtitle>
                  </Column>
                </Row>
              </Margin>
            </Column>
          </Row>
        </Margin>
      </Card>
    </>
  );
};
